import React, { useEffect, useRef } from "react";
import roomTypes from "../../../../../assets/roomTypes.json";
import Checkbox from "../../../../../components/Checkbox/Checkbox";
import CloseButton from "../../../../../components/Buttons/CloseButton/closeButton";
import RoundedButton from "../../../../../components/Buttons/RoundedButton/RoundedButton";
import TextButton from "../../../../../components/Buttons/TextButton/TextButton";
import "./roomTypesModal.css";

export default function RoomTypesModal({
  selectedRoomTypes,
  setSelectedRoomTypes,
  onRequestClose,
  props,
}) {
  const firstCheckboxRef = useRef(null);

  const handleTypeChange = (roomType) => {
    /// Removing "/" and replacing it with "&" and converting to lowercase
    const transformedRoomtype = roomType.toLowerCase().replace(/\//g, "&");

    if (selectedRoomTypes.includes(transformedRoomtype)) {
      setSelectedRoomTypes(
        selectedRoomTypes.filter((item) => item !== transformedRoomtype),
      );
    } else {
      setSelectedRoomTypes([...selectedRoomTypes, transformedRoomtype]);
    }
  };

  const handleClearButtonClick = () => {
    setSelectedRoomTypes([]);
    sessionStorage.removeItem("selectedRoomTypes");
  };

  const handleSaveButtonClick = () => {
    sessionStorage.setItem(
      "selectedRoomTypes",
      JSON.stringify(selectedRoomTypes),
    );
    onRequestClose();
  };

  useEffect(() => {
    // Disable scrolling when modal is open
    document.body.classList.add("modal-open");

    // Remove class when modal is closed
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, []);

  useEffect(() => {
    if (firstCheckboxRef.current) {
      firstCheckboxRef.current.focus();
    }
  }, []);

  return (
    <>
      <div className="room-types-modal-container">
        <div className="room-types-modal-top">
          <CloseButton onClick={onRequestClose} />
        </div>
        <div className="room-types-modal-checkboxes">
          {roomTypes.roomTypes.map((roomType, index) => (
            <Checkbox
              key={index}
              label={roomType}
              isChecked={selectedRoomTypes.includes(
                roomType.toLowerCase().replace(/\//g, "&"),
              )}
              onChange={() => handleTypeChange(roomType)}
              ref={index === 0 ? firstCheckboxRef : null}
            />
          ))}
        </div>
        <div id="rooms-types-modal-buttons">
          <TextButton label="Rensa" onClick={handleClearButtonClick} />
          <RoundedButton
            color="green"
            size="xs"
            label="Spara"
            onClick={handleSaveButtonClick}
          />
        </div>
      </div>
      <div className="room-types-modal-backdrop" onClick={onRequestClose} />
    </>
  );
}
